import { Api, LocalDictionaryFactory } from '../../api/api.module'

//#region Service Imports

import { $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $COMPILE_SERVICE_NAME, $SCOPE_SERVICE_NAME, $ELEMENT_SERVICE_NAME } from '../../../services/system'
import { DATA_TYPE_FORMAT_SERVICE_NAME, DataTypeFormatService } from '../../../services/data-type'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

//#endregion

import { MeasurementsController } from './measurements.controller'
import { MeasurementsService } from './measurements.service'

//#region Asset Imports

import './measurements.scss'
import * as TEMPLATE from './measurements.tpl.html'

//#endregion


export class MeasurementsDirective implements ng.IDirective {
    scope = {
        "hideGridster": '=?',
        "addGrid": '=?',
        "isGridInCommon": '=?',
        "isKpi": '=?',
        "source": "=source"
    }
    restrict = 'E'
    controller = [
        $SCOPE_SERVICE_NAME,
        $ELEMENT_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        $COMPILE_SERVICE_NAME,
        'api',
        'localDictionary',
        DATA_TYPE_FORMAT_SERVICE_NAME,
        'measurements',
        USER_SESSION_SERVICE_NAME,
        (
            $scope,
            $element: ng.IRootElementService,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            $compile: ng.ICompileService,
            api: Api,
            localDictionary: LocalDictionaryFactory,
            dataTypeFormatService: DataTypeFormatService,
            measurementsService: MeasurementsService,
            userSession: UserSessionService
        ) =>
            new MeasurementsController($scope, $element, $q, $timeout, $compile, api, localDictionary, dataTypeFormatService, measurementsService, userSession)
    ]
    template = TEMPLATE
    replace = true
}